import React from 'react'
import './Presentations.css'

function Presentations({ presentations }) {
  const handleViewPresentation = (e, presentationId) => {
    e.preventDefault()
    // Handle view presentation logic
  }

  return (
    <div className="presentationsMainWrapper">
      {Object.values(presentations).map((presentation) => (
        <div key={presentation.presentation_id} className="cardWrapper">
          <div className="topContainer">
            <div className="projectId">Presentation {presentation.presentation_id}</div>
            <div className="imageCardWrapper">
              <span className="backImage">
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 18 18" fill="none">
                  <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#ffffff4b"/>
                  <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#ffffff4b"/>
                  <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#ffffff4b"/>
                </svg>
              </span>
            </div>
            <div className="tagsWrapper">
              {Array.isArray(presentation.tags) 
                ? presentation.tags.map((tag, index) => (
                    <span key={index} className="tagPreview">{tag}</span>
                  ))
                : presentation.tags.split(',').map((tag, index) => (
                    <span key={index} className="tagPreview">{tag.trim()}</span>
                  ))
              }
            </div>
          </div>
          <div className="bottomContainer">
            <h1 className="presentationName">
              {presentation.title}
            </h1>
            <p className="descriptionText">
              {presentation.description}
            </p>
            <a 
              href="#" 
              className="viewPresentationBtn" 
              onClick={(e) => handleViewPresentation(e, presentation.presentation_id)}
            >
              View Presentation 
              <span className="iconWrapper"></span>
            </a>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Presentations 